import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Navbar, Nav, Container, Button, Dropdown, Collapse } from 'react-bootstrap';
import { auth } from '../config/firebaseConfig';

const AdminLayout = () => {
  const [username, setUsername] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [sidebarToggled, setSidebarToggled] = useState(false);
  const [collapseBlog, setCollapseBlog] = useState(false);
  const [collapseUsers, setCollapseUsers] = useState(false);
  const [collapseBanners, setCollapseBanners] = useState(false);
  const [collapsePages, setCollapsePages] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUsername(user.displayName || user.email || 'Kullanıcı Adı');
        setIsAuthenticated(true);
      } else {
        setUsername('Misafir');
        setIsAuthenticated(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      console.error('Çıkış yapma hatası:', error);
    }
  };

  if (isAuthenticated === null) return <div>Yükleniyor...</div>;
  if (isAuthenticated === false) return <Navigate to="/login" replace />;

  return (
    <div id="page-top">
      <div id="wrapper">
        {/* Sidebar */}
        <Navbar bg="dark" variant="dark" className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${sidebarToggled ? 'toggled' : ''}`} id="accordionSidebar">
          <Nav className="flex-column w-100">
            {/* Sidebar Brand */}
            <Nav.Item className="sidebar-brand d-flex align-items-center justify-content-center">
              <Nav.Link href="/" className="d-flex align-items-center">
                <div className="sidebar-brand-icon rotate-n-15">
                  <i className="fas fa-laugh-wink"></i>
                </div>
                <div className="sidebar-brand-text mx-3">HACIALIKARA PANEL</div>
              </Nav.Link>
            </Nav.Item>
            <hr className="sidebar-divider my-0" />

            {/* Ana Sayfa */}
            <Nav.Item>
              <Nav.Link href="/">
                <i className="fas fa-fw fa-tachometer-alt"></i>
                <span>Ana Sayfa</span>
              </Nav.Link>
            </Nav.Item>
            <hr className="sidebar-divider" />

            {/* Blog */}
            <div className="sidebar-heading">Blog</div>
            <Nav.Item>
              <Nav.Link onClick={() => setCollapseBlog(!collapseBlog)} aria-controls="collapseBlog" aria-expanded={collapseBlog}>
                <i className="fas fa-fw fa-blog"></i>
                <span>Blog</span>
              </Nav.Link>
              <Collapse in={collapseBlog}>
                <div id="collapseBlog" className="py-2 collapse-inner rounded" style={{ backgroundColor: 'var(--color-dark-green)' }}>
                  <Nav.Link href="blog-ekle" className="collapse-item">Blog Yaz</Nav.Link>
                  <Nav.Link href="kategori-ekle" className="collapse-item">Kategori Oluştur</Nav.Link>
                  <Nav.Link href="blog-duzenle" className="collapse-item">Blog Düzenle</Nav.Link>
                </div>
              </Collapse>
            </Nav.Item>

            {/* Kullanıcılar */}
            <div className="sidebar-heading">Kullanıcılar</div>
            <Nav.Item>
              <Nav.Link onClick={() => setCollapseUsers(!collapseUsers)} aria-controls="collapseUsers" aria-expanded={collapseUsers}>
                <i className="fas fa-fw fa-users"></i>
                <span>Kullanıcılar</span>
              </Nav.Link>
              <Collapse in={collapseUsers}>
                <div id="collapseUsers" className="py-2 collapse-inner rounded" style={{ backgroundColor: 'var(--color-dark-green)' }}>
                  <Nav.Link href="kullanici-ekle" className="collapse-item">Kullanıcı Ekle</Nav.Link>
                  <Nav.Link href="kullanici-duzenle" className="collapse-item">Kullanıcı Düzenle</Nav.Link>
                </div>
              </Collapse>
            </Nav.Item>

            {/* Afişler */}
            <div className="sidebar-heading">Afişler</div>
            <Nav.Item>
              <Nav.Link onClick={() => setCollapseBanners(!collapseBanners)} aria-controls="collapseBanners" aria-expanded={collapseBanners}>
                <i className="fas fa-fw fa-image"></i>
                <span>Afişler</span>
              </Nav.Link>
              <Collapse in={collapseBanners}>
                <div id="collapseBanners" className="py-2 collapse-inner rounded" style={{ backgroundColor: 'var(--color-dark-green)' }}>
                  <Nav.Link href="afis-olustur" className="collapse-item">Afiş Oluştur</Nav.Link>
                  <Nav.Link href="afis-duzenle" className="collapse-item">Afiş Düzenle</Nav.Link>
                </div>
              </Collapse>
            </Nav.Item>

            {/* Sayfalar */}
            <div className="sidebar-heading">Sayfalar</div>
            <Nav.Item>
              <Nav.Link onClick={() => setCollapsePages(!collapsePages)} aria-controls="collapsePages" aria-expanded={collapsePages}>
                <i className="fas fa-fw fa-folder"></i>
                <span>Sayfalar</span>
              </Nav.Link>
              <Collapse in={collapsePages}>
                <div id="collapsePages" className="py-2 collapse-inner rounded" style={{ backgroundColor: 'var(--color-dark-green)' }}>
                  <Nav.Link href="sayfa-olustur" className="collapse-item">Sayfa Oluştur</Nav.Link>
                  <Nav.Link href="sayfa-duzenle" className="collapse-item">Sayfa Düzenle</Nav.Link>
                  <Nav.Link href="portfolyo-ekle" className="collapse-item">Portfolyo Ekle</Nav.Link>
                  <Nav.Link href="work-hours" className="collapse-item">FL. Çalışma Takvimi</Nav.Link>
                </div>
              </Collapse>
              <Nav.Link href="/yemek-listesi-ekle">
              <i class="fas fa-pepper-hot"></i>
                <span>Yemek Listesi Ekle</span>
              </Nav.Link>
              <Nav.Link href="/yemek-listesi-duzenle">
              <i class="fas fa-pepper-hot"></i>
                <span>Yemek Listesi Düzenle</span>
              </Nav.Link>
              <Nav.Link href="/video-ekle">
              <i class="fas fa-video"></i>
                <span>Video Ekle</span>
              </Nav.Link>
            </Nav.Item>

           

            

            {/* Sidebar Toggle Butonu */}
            <hr className="sidebar-divider d-none d-md-block" />
            <div className="text-center d-none d-md-inline">
              <Button variant="outline-light" className="rounded-circle border-0" onClick={() => setSidebarToggled(!sidebarToggled)}>
                <i className="fa fa-bars"></i>
              </Button>
            </div>
          </Nav>
        </Navbar>

        {/* İçerik Alanı */}
        <div id="content-wrapper" className={`d-flex flex-column ${sidebarToggled ? 'toggled' : ''}`}>
          {/* Navbar */}
          <Navbar bg="white" expand="lg" className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <Container fluid>
              {/* Sidebar Toggle Butonu (Mobil için) */}
              <Button variant="link" className="btn btn-link d-md-none rounded-circle mr-3" onClick={() => setSidebarToggled(!sidebarToggled)}>
                <i className="fa fa-bars"></i>
              </Button>

              {/* Navbar İçeriği */}
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto"> {/* ms-auto ile sağa hizalama */}
                  {/* Bildirimler */}
                  <Dropdown>
                    <Dropdown.Toggle variant="light" id="dropdown-basic" className="d-flex align-items-center">
                      <i className="fas fa-bell fa-fw"></i>
                      <span className="badge badge-danger badge-counter">3+</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#">Bildirim 1</Dropdown.Item>
                      <Dropdown.Item href="#">Bildirim 2</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  {/* Mesajlar */}
                  <Dropdown>
                    <Dropdown.Toggle variant="light" id="dropdown-basic" className="d-flex align-items-center">
                      <i className="fas fa-envelope fa-fw"></i>
                      <span className="badge badge-danger badge-counter">7</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#">Mesaj 1</Dropdown.Item>
                      <Dropdown.Item href="#">Mesaj 2</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  {/* Kullanıcı Profili */}
                  <Dropdown>
                    <Dropdown.Toggle variant="light" id="dropdown-basic" className="d-flex align-items-center">
                      <span className="mr-2 d-none d-lg-inline text-gray-600 small">{username}</span>
                      <img className="img-profile rounded-circle" src="favicon.ico" alt="Profile" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#">Profil</Dropdown.Item>
                      <Dropdown.Item href="#">Ayarlar</Dropdown.Item>
                      <Dropdown.Item onClick={handleLogout}>Çıkış Yap</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>

          {/* Ana İçerik */}
          <div id="content"> {/* Navbar yüksekliği kadar margin ekledik */}
            <Container fluid>
              <Outlet />
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;